import styled from "styled-components";

export const StyledProductContentUploadContentListWrapper = styled.div`
  padding: 1.6rem;
  border-radius: 5px;
  background-color: #fafafa;

  .product-content-list-title {
    color: #1c1726;
    padding-bottom: 8px;
    border-bottom: 1px #d9d9d9 solid;
    font-size: 1.4rem;
    font-weight: 400;
  }
`;
export const StyledProductContentUploadContentListItem = styled.div`
  display: flex;
  gap: 2.4rem;

  .product-content-list-item-info {
    display: flex;
    gap: 2.4rem;
    /* align-items: center; */
    justify-content: space-between;
    /* flex-wrap: wrap; */
    gap: 2rem;
    flex: 1;

    .product-content-list-item-name-wrapper {
      display: flex;

      .product-content-list-item-file-icon {
        color: #595959;
        font-size: 2rem;
        /* margin-right: 8px; */
      }
      .product-content-list-item-name {
        color: #8c8c8c;
        /* overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        line-clamp: 1;
        -webkit-box-orient: vertical; */
        max-width: 32.8rem;
        /* text-overflow: ellipsis;
        white-space: nowrap; */
        /* align-self: center; */
      }
    }
  }
`;
